<template>
  <div>
    <div
      class="input-wrapper filter-wrapper d-flex flex-column justify-content-center pl-4"
      v-for="(item, i) in filterData.filter(x => x.main)"
      :key="'filter-item-' + i"
    >
      <div
        class="d-flex flex-row align-items-center"
        v-if="['select', 'lookup', 'lookup-radio', 'radio'].includes(item.type)"
      >
        <v-select
          v-model="paramAPI.filters[item.view_data ? item.view_data : item.id]"
          label="label"
          :placeholder="`Filter: ${item.label}`"
          :reduce="x => x.code"
          :options="
            Array.isArray(item.option.list_pointer.list)
              ? item.option.list_pointer.list
              : item.options
          "
          @option:selected="onFilter(item, $event)"
          @open="
            Array.isArray(item.option.list_pointer.list)
              ? null
              : getInitialData(item)
          "
          @search="searchDataOption"
          class="v-select-filter"
        >
        </v-select>
      </div>

      <date-picker
        v-else-if="['date', 'daterange'].includes(item.type)"
        :range="item.type === 'daterange'"
        format="YYYY-MM-DD"
        v-model="paramAPI.filters[item.params ? item.params : item.id]"
        input-class="input-filter-daterange"
        placeholder="Filter: Tanggal"
        value-type="format"
        @clear="paramAPI.filters[item.params ? item.params : item.id] = null"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "main-filter",
  data() {
    return {};
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/base/main-filter.vue